function state() {
  return {
    invoice: {},
    invoiceList: [],
    invoiceListMeta: {},
    selectedInsurer: "",
  };
}

export default state;
